import { Component, Input } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService } from '@spartacus/core';
import { FileDownloadService } from '@spartacus/storefront';
import { DocumentSpecificSearchService } from '../../../nyab-doc-search-page/service/Document-specific/document-specific-search.service';
import { NgIf } from '@angular/common';
import { HighlightSearchPipe } from '../../../../pipes/highlightSearch.pipe';


@Component({
    selector: 'app-kb-document-list',
    templateUrl: './kb-document-list.component.html',
    styleUrls: ['./kb-document-list.component.scss'],
    imports: [NgIf, HighlightSearchPipe]
})
export class KbDocumentListComponent {
  @Input() product: any;
  @Input() searchQuery: any;
  isMobile!: boolean;
  addfav: boolean = false;
  isLoggedIn: boolean = false;
  tooltip: boolean = false;
  constructor(public breakpointObserver: BreakpointObserver,
    private AuthService: AuthService,
    private service: DocumentSpecificSearchService,
    private fileDownloadService: FileDownloadService) {
  }
  ngOnChanges() {
    if (this.product?.isFavorite) {
      this.addfav = true;
    }
    console.log(this.searchQuery)
  }
  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
    this.AuthService.isUserLoggedIn().subscribe((data) => {
      if (data) {
        this.isLoggedIn = data;
      }
      else {
        this.isLoggedIn = false;
      }
    })
  }
  downloadPopup(doc: any) {
    /* const width = window.innerWidth - 500;
    this.openDialog.open(KbDownloadPopupComponent, { data: doc, minWidth: width, maxHeight: '500px' }); */
    console.log(doc);
    window.open(doc.url, `${doc.fileName}.pdf`);
    // this.fileDownloadService.download(doc, `${doc.fileName}.pdf`);
  }

  SubscribeDoc(data: any) {
    if (this.addfav) {
      this.unSubscribeDoc(data);
    } else {
      if (this.service.inPdp) {
        this.service.getDownloadPopup().subscribe((response: any) => {
          let payLoad = {
            code: data.code,
            email: response.displayUid,
            name: response.name,
            revision: data.revision,
            language: data.isoCode
          }
          this.service.addToFavFromPdp(payLoad).subscribe();
          // this.service.addToFavFromPdp(payLoad).subscribe((res: any) => {
          //   if (res.status == 'success') {
          //     this.globalmsgService.add({ key: 'common.text_notification_for_confirm_subscription' }, GlobalMessageType.MSG_TYPE_INFO);
          //   }
          // });
        });
      } else {
        this.service.getDownloadPopup().subscribe((response: any) => {
          let payLoad = {
            code: data.code,
            email: response.displayUid,
            name: response.name,
            revision: data.revision,
            language: data.isoCode
          }
          this.service.exceptPdpAddToFavFrom(payLoad).subscribe();
          // this.service.exceptPdpAddToFavFrom(payLoad).subscribe((res: any) => {
          //   if (res.status == 'success') {
          //     this.globalmsgService.add({ key: 'common.text_notification_for_confirm_subscription' }, GlobalMessageType.MSG_TYPE_INFO);
          //   }
          // });
        });
      }
    }

  }
  unSubscribeDoc(data: any) {
    if (this.service.inPdp) {
      this.service.removeFavFromPdp(data).subscribe();
    } else {
      this.service.removeFavDoc(data).subscribe();
    }
  }
}
